// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
body {
    margin: 0;
    font-family: 'Noto Sans', sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    background-color: #EFF6FF;
    .tooltip
            {
                font-size: 14px;
                font-family: 'Noto Sans', sans-serif;
            }
}

code {
    font-family: 'Noto Sans', sans-serif;
}
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":";AACA;IACI,SAAS;IACT,oCAAoC;IACpC,mCAAmC;IACnC,kCAAkC;IAClC,yBAAyB;IACzB;;gBAEY,eAAe;gBACf,oCAAoC;YACxC;AACZ;;AAEA;IACI,oCAAoC;AACxC","sourcesContent":["\nbody {\n    margin: 0;\n    font-family: 'Noto Sans', sans-serif;\n    -webkit-font-smoothing: antialiased;\n    -moz-osx-font-smoothing: grayscale;\n    background-color: #EFF6FF;\n    .tooltip\n            {\n                font-size: 14px;\n                font-family: 'Noto Sans', sans-serif;\n            }\n}\n\ncode {\n    font-family: 'Noto Sans', sans-serif;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
